import type { NOTIFICATION_LEVELS_NAMES } from 'pages/notifications/constants';

/**
 * Returns a high-contrast link color based on the alert severity level.
 * @param severity - The severity level (critical, warning, info, success)
 * @returns {string} - A suitable link color for the given severity.
 */
export const getLinkColorBySeverity = (severity: keyof typeof NOTIFICATION_LEVELS_NAMES): string => {
    switch (severity) {
        case 'critical':
            return '#ffffff';
        case 'warning':
            return '#000000';
        case 'info':
            return '#ffffff';
        default:
            return '#2196f3';
    }
};
